import { isKnownTransport, transportIcon, transportLabel, type TransportType } from '../lib/transportation';
import clsx from 'clsx';

export function TransportChip({ type, class: extraClass }: { type: unknown; class?: string }) {
  if (!isKnownTransport(type)) return null;
  const Icon = transportIcon(type as TransportType);
  return (
    <span
      class={clsx(
        'inline-flex items-center gap-1.5 rounded-full bg-surface-muted px-2.5 py-1 text-xs font-medium text-text',
        extraClass,
      )}
    >
      <Icon size={14} aria-hidden="true" />
      <span>{transportLabel(type as TransportType)}</span>
    </span>
  );
}
